import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../App.css';
import { FaHome, FaClipboardCheck, FaSignOutAlt, FaClock, FaUserCheck, FaLayerGroup, FaClipboardList, FaExclamation, FaUserFriends } from 'react-icons/fa';
import imagen2 from '../img/get_view2.png';

const Sidebar = () => {
  const navigate = useNavigate();
  const handleInicioClick = () => navigate('/MenuSeniorGET');
  const handlePorAprobarSeniorGETClick = () => navigate('/RevisarActividadesSeniorGET');
  const handleActividadGETClick = () => navigate('/ActividadGET2');
  const handleLiderGETClick = () => navigate('/VerLiderSubrogante2');
  const handleAsistentesGETClick = () => navigate('/VerAsistente2');
  const handleFinalizadasClick = () => navigate('/SolicitudesCompletadasSeniorGET');
  const handleSolicitudesAnuladas2Click = () => navigate('/SolicitudesAnuladas2');
  const handleExitClick = () => {
    navigate('/'); // Redirige al usuario a la página de inicio de sesión o la ruta principal
    localStorage.clear(); // Elimina todos los elementos de localStorage
    window.location.reload(); // Refresca la página
  };

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <img src={imagen2} alt="GET View Logo" className="sidebar-logo" />
      </div>
      <div className="sidebar-section">
        <p>Aplicaciones</p>
        <div className="profile-link" onClick={handleInicioClick}>
          <FaHome /> Inicio
        </div>
        <div className="profile-link" onClick={handlePorAprobarSeniorGETClick}>
          <FaClock /> Solicitudes por aprobar
        </div>
        <div className="profile-link" onClick={handleActividadGETClick}>
          <FaClipboardList /> Actividades GET
        </div>
        <div className="profile-link multiline-text" onClick={handleLiderGETClick}>
          <FaUserCheck /> Ver líderes y subrogantes de grupo
          </div>
        <div className="profile-link" onClick={handleAsistentesGETClick}>
          <FaLayerGroup /> Ver staff
        </div>
        <div className="profile-link" onClick={handleSolicitudesAnuladas2Click}>
          <FaExclamation /> Solicitudes anuladas
        </div>
        <div className="profile-link" onClick={handleFinalizadasClick}>
          <FaClipboardCheck />  Solicitudes finalizadas
        </div>
      </div>
      <div className="sidebar-section bottom-items">
        <p>Otros</p>
        <div className="profile-link" onClick={handleExitClick}>
          <FaSignOutAlt /> Cerrar Sesión
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
